import { getBitValueFromHex, generateMissingBits } from '../BitValueCalculator'
import { renderNormalRow } from './NormalRowRenderer'


export const renderDefaultRows = (rows, byteIndex, pageKey, currentHexValue, handleCellClick) => {
  const allRows = [];
  const normalRows = rows.filter(row => row.bit !== 0); 
  
  const processedRows = generateMissingBits(normalRows, byteIndex, pageKey, currentHexValue);
  
  for (let bitPos = 8; bitPos >= 1; bitPos--) {
    const row = processedRows.find(r => r.bit === bitPos);
    if (row) {
      const bitValue = getBitValueFromHex(byteIndex, bitPos, currentHexValue, pageKey);
      allRows.push(renderNormalRow({...row, value: bitValue}, byteIndex, true, handleCellClick));
    }
  }
  
  return allRows;
}
